import { Component, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faDollar, faFileWord, faLock, faMoneyBill, faTablet, faUser } from '@fortawesome/free-solid-svg-icons';
import { Subscriber, Subscription } from 'rxjs';
import { User } from 'src/app/_models';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'mayne-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {

  public navParents: any = [];
  faUser = faUser;
  faDocument = faFileWord;
  faPadlock = faLock;

  menu = [
    {
      icon: '/assets/icons/user.svg',
      text: 'User Management',
      path: '/users',
      active: true,
      children: null,
      subAdmin: true,
    },
    /* {
       icon: this.faDocument,
       text: 'Reports',
       path: 'reports',
       children: null,
       active: false,
     },*/
    {
      icon: '/assets/icons/Site_Users.svg',
      text: 'RDS Users',
      path: '/rds',
      children: null,
      active: false,
      subAdmin: true,
    },
    {
      icon: faMoneyBill,
      text: 'Discounts',
      path: '/discount',
      children: null,
      active: false,
    },
    {
      icon: faTablet,
      text: 'Warehouse Devices',
      path: '/warehouse-devices',
      children: null,
      active: false,
    },
    {
      icon: '/assets/icons/Site_Users.svg',
      text: 'Site Users',
      path: '/manage',
      children: null,
      active: false,
    },
    {
      icon: '/assets/icons/Site_Users.svg',
      text: 'Stats Portal',
      path: '/stats',
      children: null,
      active: false,
    }
  ];

  userType: string | undefined = '';

  constructor(private router: Router, private accountService: AccountService, private ngZone: NgZone) {

  }

  ngOnInit() {
    this.navParents = [1, 2, 3, 4, 5, 6];


    this.accountService.refreshUser().subscribe((x: User) => {
      console.log(x);
      this.userType = x.user_type;
    });


    this.router.events.forEach((event: any) => {
      if (event instanceof NavigationEnd) {
        this.menu.forEach(x => {
          x.active = x.path == `${event.url}`;
        });
        this.ngZone.run(() => {
          console.log('trigger update');

          console.log(this.menu);
        });
      }
    });

  }

  filterMenu(menu: any) {
    if (this.userType == 'admin') {
      return this.menu;
    }

    if (this.userType == 'subadmin') {
      return this.menu.filter((x: any) => x.subAdmin === true);
    }

    return this.menu.filter((x: any) => x.subAdmin === true);
  }


  onClickNav(url: string) {

    this.router.navigate([url]);
  }
}